import axios from "axios";

//export const baseUrl = 'http://localhost:5166';
export const baseUrl = 'https://api.snrh.panaceaschool.in';
//export const baseUrl = '';
export const LogoName = 'PANACEASchool';
export const FooterName = 'PANACEAINDIA';

export const LEAVING_CERTIFICATE_OL = 'LEAVINGCERTIFICATEOL';
export const LEAVING_CERTIFICATE = 'LEAVINGCERTIFICATE';
export const BONAFIDE_CERTIFICATE = 'BONAFIDECERTIFICATE';
export const FORM15_CERTIFICATE = 'FORM15CERTIFICATE';
export const NIRGAMUTARA_CERTIFICATE = 'NIRGAMUTARACERTIFICATE';
export const ATTEMPT_CERTIFICATE_Name = 'ATTEMPTCERTIFICATE';

export const SaralImport_Report = 'SaralImportReport';
export const SaralProfileUpdation_Report = 'SaralProfileUpdationReport';
export const UDISEImport_Report = 'UDISEImportReport';
export const UDISEProfileUpdation_Report = 'UDISEProfileUpdationReport';
export const ApaarId_Report = 'ApaarIdReport';
export const Aadhaar_Report = 'AadhaarReport';
export const Genderwise_Report = 'GenderwiseReport';
export const CategoryWise_Report = 'CategoryWiseReport';
export const BoardWise_Report = 'BoardWiseReport';
export const AdmissionSource_Report = 'AdmissionSourceReport';

export const loggedUser = localStorage.getItem("userID");
export const PageSize = 20;

export const CastePageSize = 100;

// Arrays for converting numbers into words
export const ones = ["", "First", "Second", "Third", "Fourth", "Fifth", "Sixth", "Seventh", "Eighth", "Ninth", "Tenth", "Eleventh", "Twelfth", "Thirteenth", "Fourteenth", "Fifteenth", "Sixteenth", "Seventeenth", "Eighteenth", "Nineteenth"];
export const tens = ["", "Ten", "Twenty", "Thirty"];
export const months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const yearOnes = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
export const yearTens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
export const yearPrefixes = ["", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];

// Function to convert date into words
export const convertDateToWords = (dateString) => {
  if (!dateString) return "";
  
  const date = new Date(dateString);
  const day = date.getDate();
  const month = months[date.getMonth() + 1];
  const year = date.getFullYear();

  const dayInWords = convertDayToWords(day);
  const yearInWords = convertYearToWords(year);

  return `${dayInWords} ${month} ${yearInWords}`;
};

export const convertDayToWords = (day) => {
  if (day <= 19) return ones[day];
  const dayTens = Math.floor(day / 10);
  const dayOnes = day % 10;
  return `${tens[dayTens]} ${ones[dayOnes]}`;
};

export const convertYearToWords = (year) => {
  const yearStr = year.toString();
  const firstTwoDigits = parseInt(yearStr.slice(0, 2)); // e.g., "20" for 2000, "19" for 1999
  const lastTwoDigits = parseInt(yearStr.slice(2));     // e.g., "00" for 2000, "99" for 1999

  let yearInWords = "";

  // Handle the first two digits for centuries (e.g., 1900, 2000)
  if (firstTwoDigits === 19) {
    yearInWords = "Nineteen";
  } else if (firstTwoDigits === 20) {
    // Special case for 2000
    if (lastTwoDigits === 0) {
      return "Two Thousand";
    }
    yearInWords = "Two Thousand";
  }

  // Handle the last two digits
  if (lastTwoDigits <= 19) {
    // Use yearOnes for numbers 1-19
    yearInWords += ` ${yearOnes[lastTwoDigits]}`;
  } else {
    const tensPlace = Math.floor(lastTwoDigits / 10);
    const onesPlace = lastTwoDigits % 10;
    yearInWords += ` ${yearTens[tensPlace]} ${yearOnes[onesPlace]}`;
  }

  return yearInWords.trim();
};

export const convertDateToMarathi = (date) => {
  const options = { year: "numeric", month: "long", day: "numeric" };
  return new Intl.DateTimeFormat("mr-IN", options).format(new Date(date));
};

export const currentUserRole = localStorage.getItem("Role");

export function formatDateToDDMMYYYY(dateString) {
  const date = new Date(dateString);

  if (isNaN(date)) {
    return "Invalid Date";
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}


export const PendingStudentError = 'Your application is pending for approval. Please contact administrator.';
export const RejectedStudentError = 'Your application is not approved. Please contact administrator.';

export const formatLCVersion = (value) => {
  // Check if the certificate number starts with "DUPLICATE" and has a number following it
  const regex = /^DUPLICATE(\d+)$/;
  const match = value.toUpperCase().match(regex);

  if (match) {
    // Separate "DUPLICATE" and the number with a hyphen
    return `DUPLICATE-${match[1]}`;
    
  }
  // Return the original if no formatting is needed
  return value.toUpperCase();
}

export const fetchAdminSchoolId = async () => {
  try {
    const url = `${baseUrl}/api/PersonalDetails/PersonalDetailsByAdmin?AdminId=${localStorage.getItem("userID")}`;
    const response = await axios.get(url);
    if (response.data && response.data.length > 0) {
      return response.data[0].schoolId;
    }
    return null; // Return null if no schoolId is found
  } catch (error) {
    console.error("Error fetching data", error);
    return null; // Handle errors gracefully
  }
};

export const sendWhatsAppTemplate = async (phoneNumber, templateId, variables) => {
  const apiToken = "11446|xR4BBpvQmkRyJXIW0dWSneCK6L2zzDWkIe7KPDMB3c98b270";
  const phoneNumberId = "693821633824945"; // your phone number ID
  const url = "https://chatbotmarketing.in/api/v1/whatsapp/send/template";

  try {
    // Prepare form data
    const formData = new URLSearchParams();
    formData.append("apiToken", apiToken);
    formData.append("phone_number_id", phoneNumberId);
    formData.append("template_id", templateId);

    // Add all template variables dynamically
    for (const [key, value] of Object.entries(variables)) {
      formData.append(key, value);
    }

    formData.append("phone_number", phoneNumber);

    const response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    if (response.status === 200) {
      console.log("✅ WhatsApp template sent successfully!");
      return true;
    } else {
      console.error("❌ Failed to send template:", response.data);
      return false;
    }
  } catch (error) {
    console.error("⚠️ Error sending WhatsApp template:", error.message);
    return false;
  }
};

export const currentDate = () => {
  var date = new Date();
  return (
    String(date.getDate()).padStart(2, "0") +
    "-" +
    String(date.getMonth() + 1).padStart(2, "0") +
    "-" +
    date.getFullYear() +
    " " +
    String(date.getHours()).padStart(2, "0") +
    ":" +
    String(date.getMinutes()).padStart(2, "0") +
    ":" +
    String(date.getSeconds()).padStart(2, "0")
  );
};


export const subjectGroupOptions = [
  { id: 1, value: "General" },
  { id: 2, value: "Bifocal" },
];

export const subjectTypeOptions = [
  { id: 1, value: "Theory" },
  { id: 2, value: "Practical" },
  { id: 3, value: "Oral" },
  { id: 4, value: "Journal" },
  { id: 5, value: "Project" }
];

export const subjectCategoryOptions = [
  { id: 1, value: "Compulsory" },
  { id: 2, value: "Optional" },
  { id: 3, value: "Language" },
];

export const documentsList = [
  // { id: "marksheet10", label: "Marksheet 10th", category: "Academic Records" },
  // { id: "marksheet11", label: "Marksheet 11th", category: "Academic Records" },
  // { id: "marksheet12", label: "Marksheet 12th", category: "Academic Records" },
  { id: "prevStandardMarksheet", label: "Previous Standard Marksheet", category: "Academic Records" },
  { id: "passingCertificate", label: "Passing Certificate", category: "Academic Records" },
  { id: "lcCertificate", label: "LC", category: "Academic Records" },
  { id: "migrationCertificate", label: "Migration Certificate", category: "Academic Records" },

  { id: "aadhaarCardStudent", label: "Aadhaar Card (Student)", category: "KYC Details" },
  { id: "adhaarCardParent", label: "Aadhaar Card (Parent)", category: "KYC Details" },
  { id: "casteCertificate", label: "Caste Certificate", category: "KYC Details" },
  { id: "nonCreamyLayer", label: "Non-Creamy Layer", category: "KYC Details" },
  { id: "incomeCertificate", label: "Income Certificate", category: "KYC Details" }, 
  { id: "signature", label: "Signature", category: "KYC Details" },
   { id: "photo", label: "Photo", category: "KYC Details" },
  { id: "motherPhoto", label: "Mother Photo", category: "KYC Details" },
  { id: "fatherPhoto", label: "Father Photo", category: "KYC Details" },
  { id: "bankPassbook", label: "Bank Passbook", category: "KYC Details" },

  { id: "specialCasesSportCertificate", label: "Special Cases Sport Certificate", category: "Special Cases/Reservations" },
  { id: "disabilityCertificate", label: "Disability Certificate", category: "Special Cases/Reservations" },
  { id: "exServiceman", label: "Ex-Serviceman", category: "Special Cases/Reservations" },
  { id: "servicemanCertificate", label: "Serviceman", category: "Special Cases/Reservations" },
  { id: "orphanCertificate", label: "Orphan Certificate", category: "Special Cases/Reservations" }
];

export const userTeacherdocumentsList = [  
  { id: "panCard", label: "Pan Card", category: "KYC Details", level:"User" },
  { id: "photo", label: "Photo", category: "KYC Details", level:"User" },
  { id: "aadhaarCardUser", label: "Aadhaar Card (User)", category: "KYC Details", level:"User" },
  { id: "signature", label: "Signature", category: "KYC Details", level:"User" },

  { id: "individualApproval", label: "Individual Approval", category: "Official Details", level:"Admin" },
  { id: "joiningReport", label: "Joining Report", category: "Official Details", level:"Admin" },
  { id: "acceptanceLetter", label: "Acceptance Letter", category: "Official Details", level:"Admin" },
];

export const userRoles = [
  {    id: "TEACHER", name  : "Teacher"  },
  {    id: "EXAMHEAD", name  : "Exam Head"  },
  {    id: "RECEPTIONIST", name  : "Receptionist"  },
  {    id: "ACCOUNTANT", name  : "Accountant"  }
]

export const disabilityTypes = [
  { id: "Autism Spectrum Disorder", value: "Autism Spectrum Disorder" },
  { id: "Blindness", value: "Blindness" },
  { id: "Cerebral Palsy", value: "Cerebral Palsy" },
  { id: "Deaf", value: "Deaf" },
  { id: "Dumb", value: "Dumb" },
  { id: "Dwarfism", value: "Dwarfism" },
  { id: "Handicapped/Spastic", value: "Handicapped/Spastic" },
  { id: "Hearing Impairment", value: "Hearing Impairment" },
  { id: "Intellectual Disability", value: "Intellectual Disability" },
  { id: "Learning disability", value: "Learning disability" },
  { id: "Leprosy Cured Persons", value: "Leprosy Cured Persons" },
  { id: "Locomotor Disability", value: "Locomotor Disability" },
  { id: "Low Vision", value: "Low Vision" },
  { id: "Mental Illness - New", value: "Mental Illness - New" },
];

export const examTypes = [
  {id: "Unit1", value: "Unit1"},
  {id: "Unit2", value: "Unit2"},
  {id: "Term1", value: "Term1"},
  {id: "Final", value: "Final"}
]

export const numberToWords = (num) => {
  const ones = [
    "Zero", "One", "Two", "Three", "Four", "Five",
    "Six", "Seven", "Eight", "Nine", "Ten", "Eleven",
    "Twelve", "Thirteen", "Fourteen", "Fifteen",
    "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];

  const tens = [
    "", "", "Twenty", "Thirty", "Forty",
    "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  // 0–19
  if (num < 20) return ones[num];

  // 20–99
  if (num < 100) {
    return (
      tens[Math.floor(num / 10)] +
      (num % 10 ? " " + ones[num % 10] : "")
    );
  }

  // 100–999
  if (num < 1000) {
    return (
      ones[Math.floor(num / 100)] +
      " Hundred" +
      (num % 100 ? " " + numberToWords(num % 100) : "")
    );
  }

  // 1000
  if (num === 1000) return "One Thousand";

  return "Out of range";
};